import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../routes/pageRoutes";
import CartTable from "./component/CartTable";
import { fetchCartDetails } from "../../redux/action/orderAction";

const Cart = () => {
  const dispatch = useDispatch();
  const { isLoading ,cartList} = useSelector((state) => state?.orderReducer);

  useEffect(() => {
    dispatch(fetchCartDetails())
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Cart"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Cart", path: `${pageRoutes?.home}/` },
        ]}
      />
      <CartTable cartList={cartList}/>

      <Footer />
    </div>
  );
};

export default Cart;
